import { useEffect } from 'react';

import { useRouter } from 'next/router';
import Script from 'next/script';

export const GA_ID = process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID || '';
export const UA_ID = process.env.NEXT_PUBLIC_UNIVERSAL_ANALYTICS_ID || '';
const RETARGETING_GID = process.env.NEXT_PUBLIC_RETARGETING_GID || '';
const FACEBOOK_ID = process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID || '';

// PVを測定する
export const gaPageview = (path: string) => {
  window.gtag('config', GA_ID, {
    page_path: path,
  });
};

export const uaPageview = (path: string) => {
  window.gtag('config', UA_ID, {
    page_path: path,
  });
};

declare global {
  interface Window {
    gtag: any;
  }
}

// GAイベントを発火させる
export const gtagEvent = ({ event, component, page_label, event_label = '', event_label2 = '' }: Event) => {
  if (!GA_ID) {
    return;
  }

  window.gtag('event', event, {
    component: component,
    page_label: page_label,
    event_label: event_label,
    event_label2: event_label2,
  });
};

// _app.tsx で読み込む
export const usePageView = () => {
  const router = useRouter();

  useEffect(() => {
    if (!GA_ID) {
      return;
    }

    const handleRouteChange = (path: string) => {
      if (UA_ID) {
        uaPageview(path);
      }
    };

    router.events.on('routeChangeComplete', handleRouteChange);
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router.events]);
};

// _app.tsx で読み込む
export const GoogleAnalytics = () => (
  <>
    <Script defer src={`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`} strategy="afterInteractive" />
    <Script
      defer
      id="gtag-inlie-script"
      dangerouslySetInnerHTML={{
        __html: `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', '${GA_ID}', {
                page_path: window.location.pathname,
              });
              gtag('config', '${RETARGETING_GID}');
            `,
      }}
      strategy="afterInteractive"
    />
    <Script
      defer
      id="facebook-script"
      dangerouslySetInnerHTML={{
        __html: `
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '${FACEBOOK_ID}');
            fbq('track', 'PageView');
            `,
      }}
      strategy="afterInteractive"
    />
  </>
);

export type Event = {
  event: string;
  component: string;
  page_label: string;
  event_label?: string;
  event_label2?: string;
};
